import { SITE, waLink, WA_DEFAULT_MESSAGE, track } from "@/constants/site";

export default function MobileBottomBar() {
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-background-200 bg-background-50 p-2 md:hidden">
      <div className="grid grid-cols-2 gap-2">
        <a
          href={SITE.phoneHref}
          onClick={() => track("phone_click")}
          className="flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-300 text-sm font-bold text-primary-700"
        >
          <i className="ri-phone-line text-lg" aria-hidden="true" />
          Ligar
        </a>
        <a
          href={waLink(WA_DEFAULT_MESSAGE)}
          target="_blank"
          rel="noreferrer"
          onClick={() => track("whatsapp_click")}
          className="flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-[#25D366] text-sm font-bold text-background-50"
        >
          <i className="ri-whatsapp-line text-lg" aria-hidden="true" />
          WhatsApp
        </a>
      </div>
    </div>
  );
}